"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var IntlInstanceCache =
/** @class */
function () {
  function IntlInstanceCache() {
    var _this = this;

    this.dateTimeCache = {};
    this.numberCache = {};

    this.getDateTime = function (locale, options) {
      if (options === void 0) {
        options = {};
      }

      var key = JSON.stringify([locale, options]);
      var intlInstance = _this.dateTimeCache[key];

      if (!intlInstance) {
        intlInstance = new Intl.DateTimeFormat(locale, options);
        _this.dateTimeCache[key] = intlInstance;
      }

      return intlInstance;
    };

    this.getNumber = function (locale, options) {
      if (options === void 0) {
        options = {};
      }

      var key = JSON.stringify([locale, options]);
      var intlInstance = _this.numberCache[key];

      if (!intlInstance) {
        intlInstance = new Intl.NumberFormat(locale, options);
        _this.numberCache[key] = intlInstance;
      }

      return intlInstance;
    };
  }

  return IntlInstanceCache;
}();

exports.IntlInstanceCache = IntlInstanceCache;
exports.default = new IntlInstanceCache();